export default __webpack_public_path__ + "static/media/down-arrow.e3ac7961.svg";